import { gql } from "lib/apolloClient";
import {
  classItemFragment,
  courseItemFragment,
  courseItemFragmentV2,
} from "./LearningCoursesListFragments";

export const getCoursesFeedQuery = gql`
  query getCoursesFeed(
    $organizationId: ID!
    $after: String
    $filters: LearningCourseFilters
    $classesFilters: LearningCourseClassFilter
    $gradeFilters: LearningCourseGradeFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        learningCourses(first: 20, after: $after, filters: $filters) {
          edges {
            node {
              ...courseItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${courseItemFragment}
`;

export const getCoursesFeedV2Query = gql`
  query getCoursesFeed(
    $organizationId: ID!
    $after: String
    $filters: LearningCourseFilters
    $classesFilters: LearningCourseClassFilter
    $termFilters: TermFilters
    $orderBy: OrderByEnum
    $orderByDirection: OrderByDirectionEnum
    $gradeFilters: LearningCourseGradeFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        learningCourses(
          first: 20
          after: $after
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          edges {
            node {
              ...courseItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${courseItemFragmentV2}
`;

export const getClassesFeedQuery = gql`
  query getClassesFeed(
    $organizationId: ID!
    $filters: CourseFilterInput
    $after: String
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(first: 20, after: $after, filters: $filters) {
          edges {
            node {
              ...classItem
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${classItemFragment}
`;

export const getSubjectsAndGradingPeriodsQuery = gql`
  query getSubjectsAndGradingPeriods(
    $id: ID!
    $subjectFilters: SubjectFilterInput
    $curriculumIds: [ID!]
    $gradingPeriodsFilters: TermFilters!
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        subjects(filters: $subjectFilters) {
          id
          name
          icon
          grades {
            id
            name
          }
          curriculumProgram {
            id
            label
            type
            nodeInterfaceType
          }
          associatedLevels {
            id
            label
            type
          }
        }
        curriculumPrograms(curriculumIds: $curriculumIds) {
          id
          gradingPeriods(filters: $gradingPeriodsFilters) {
            edges {
              node {
                id
                label
                startDate
                endDate
                academicYear {
                  id
                }
                curriculumProgram {
                  id
                  label
                  type
                  nodeInterfaceType
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getOrganizationSubjectGroupsQuery = gql`
  query getOrganizationSubjectGroups(
    $organizationId: ID!
    $filters: SubjectGroupFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjectGroups(filters: $filters) {
          id
          name
          curriculumProgram {
            id
            label
            type
            nodeInterfaceType
          }
        }
      }
    }
  }
`;

export const getOrganizationGenericTagsQuery = gql`
  query getOrganizationGenericTags(
    $organizationId: ID!
    $filters: GenericTagsFilter
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        genericTagsV2(filters: $filters) {
          id
          label
          abbreviation
          curriculumProgram {
            id
            label
            type
            nodeInterfaceType
          }
        }
      }
    }
  }
`;

export const getDpSubjectVariantsQueryV3 = gql`
  query getOrganizationSubjectVariantsV3($id: ID!, $curriculumIds: [ID!]) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        curriculumPrograms(curriculumIds: $curriculumIds) {
          ... on IbDpCurriculumProgram {
            id
            subjectVariants(filters: { archivalState: ALL }) {
              subject {
                name
                id
                icon
                iconType
                type
                ibOfferedSubject {
                  id
                  contentSubject {
                    id
                    assessmentYearTitle
                    assessmentYearEndsOn
                  }
                }
                curriculumProgram {
                  id
                }
                isArchived
                associatedLevels {
                  id
                  label
                  type
                }
                flatVariants(filters: { archivalState: ALL }) {
                  level {
                    id
                    label
                  }
                  responseLanguage {
                    id
                    label
                  }
                  isArchived
                }
                subjectGroup {
                  id
                  globalSubjectGroup {
                    id
                  }
                }
              }
              subjectGroup {
                id
                name
                type
                globalSubjectGroup {
                  id
                  name
                  type
                }
                displaySequence
              }
            }
          }
        }
      }
    }
  }
`;

export const getMappedLearningCoursesCountQuery = gql`
  query getMappedLearningCoursesCount(
    $organizationId: ID!
    $filters: LearningCourseFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        learningCourses(filters: $filters) {
          count {
            totalCount
          }
        }
      }
    }
  }
`;
